import React, { useState } from "react";

import GoAiguaCheckbox from "components/generic/goaiguacheckbox";
import UserEditModal from "./usereditmodal";

import { faEdit, faEye } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useIntl } from "react-intl";

type UsersTableActionType = {
    props: any;
};

const UsersTableAction = (props: any) => {
    const intl = useIntl();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const renderCheckboxIfValue = () => {
        return (
            <React.Fragment>
                <div
                    className="c-user-table-action"
                    onClick={() => setIsModalOpen(true)}
                >
                    <FontAwesomeIcon icon={faEdit} />
                    <label>
                        {intl.formatMessage({ id: "app.users.edit" })}
                    </label>
                </div>
                <UserEditModal
                    isOpen={isModalOpen}
                    setIsOpen={setIsModalOpen}
                    userUid={props && props.data ? props.data.uid : ""}
                    userDataRef={props}
                />
            </React.Fragment>
        );
    };
    return renderCheckboxIfValue();
};

export default UsersTableAction;
